module.exports = __webpack_public_path__ + "static/media/tg.6cd7a08c.svg";